export enum EPDContentDeclarationProductType {
  Average = 'AverageProduct',
  BestProduct = 'BestProduct',
  WorstProduct = 'WorstProduct',
}
